import { gql } from '@apollo/client';
import Fragments from './fragments';

export const DOCUMENT_TYPE_PROPERTY_QUERY = gql`
  query documentTypeProperty($documentTypeId: Int!, $propertyId: Int!) {
    documentTypeProperty(documentTypeId: $documentTypeId, propertyId: $propertyId) {
      ...documentTypePropertyItem
      states {
        ...documentTypePropertyXState
      }
    }
  }
  ${Fragments.documentTypePropertyItem}
  ${Fragments.documentTypePropertyXState}
`;

export const PROPERTY_DETAILS_QUERY = gql`
  query dictionaryPropertyDetails($propertyId: Int!) {
    dictionaryPropertyDetails(propertyId: $propertyId) {
      propertyValue
    }
  }
`;

export const DICTIONARY_ALLOWED_STATES_QUERY = gql`
  query dictionaryAllowedStates($documentTypeId: Int!) {
    dictionaryAllowedStates(documentTypeId: $documentTypeId) {
      documentStateId
      documentStateName
    }
  }
`;
